import React, { Component } from 'react';
import Slider from 'rc-slider';
import { observer } from 'mobx-react';

import 'rc-slider/assets/index.css';
import './Progress.css';

import { DataStore } from '../DataStore';

@observer
class Progress extends Component {

    timeFormat = (time) => {
        let surplusMinite,
        surplusSecond,
        cTime;
        //将剩余秒数转化为分钟
        surplusMinite = Math.floor((time / 60) % 60);
        //将剩余秒数转化为秒钟
        surplusSecond = Math.floor(time % 60);
        if(surplusMinite < 10){
            surplusMinite = '0' + surplusMinite;
        }
        if(surplusSecond < 10){
            surplusSecond = '0' + surplusSecond;
        }
        cTime = surplusMinite + ':' + surplusSecond;

        return cTime;
    }

    sliderValue = (time) => {
        if(time <= 0) return 0;
        return Math.floor(time / DataStore.coutSongMassge.Duration * 100 * 10) / 10;
    }

    onChange = (value) => {
        if(DataStore.audio) DataStore.audio.currentTime = Math.floor(value / 100 * DataStore.coutSongMassge.Duration *10) / 10;
        //DataStore.currentTime = Math.floor(value / 100 * DataStore.coutSongMassge.Duration);
    }

    render() {
        return (
            <div className="progress-box" value={this.sliderValue(DataStore.currentTime)}>
                <div className="song-msg">
                    <div className="song-title ell">{DataStore.coutSongMassge.SongName}-{DataStore.coutSongMassge.SingerName}</div>
                    <div className="song-time">{this.timeFormat(DataStore.currentTime)} / {this.timeFormat(DataStore.coutSongMassge.Duration)}</div>
                </div>
                <Slider 
                    defaultValue={0} 
                    value={this.sliderValue(DataStore.currentTime)}
                    disabled={DataStore.disabled}
                    tipFormatter={null}
                    step={0.1}
                    min={0}
                    max={100}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}

export default Progress;


// WEBPACK FOOTER //
// ./src/components/Progress.js